import { data } from './data';

interface IData {
 [key: string]: {
   currency: string,
   symbol: string
 };
}

export const getCurrencyInfo = (currencyCode: string) => {
  const code = currencyCode.toUpperCase();

  if (!Object.prototype.hasOwnProperty.call(data, code)) {
    return {
      currency: currencyCode,
      symbol: currencyCode
    }
  }

  return (data as IData)[code];
};
